export const COGNITO_CONFIG = {
  UserPoolId: "us-east-2_HqTHuK0cF",
  ClientId: "1iaf61ncip8oh9if33969dct1b",
  Region: "us-east-2", // example: 'ap-south-1'
  ClientSecret: "lm26uamid4utdven7iesd6jsrnv36hck46posjb48luf686vrli",
};
